import React, { createContext, useContext, useRef, useState } from 'react';
import { toast } from 'sonner';
import api from '../../../utils/axios';

const Ctx = createContext({ cfg: { vista: {}, export: {} }, puede: false, guardar: () => {} });

// Columnas que ven todos: las elige un administrador y quedan guardadas en el servidor (los cambios se guardan en orden).
export const AtencionColumnasProvider = ({ inicial, puede, children }) => {
  const [cfg, setCfg] = useState(() => ({ vista: inicial?.vista || {}, export: inicial?.export || {} }));
  const guardado = useRef(cfg);
  const cola = useRef(Promise.resolve());
  const guardar = (parte) => {
    setCfg((c) => ({ ...c, ...parte }));
    cola.current = cola.current.then(async () => {
      try {
        await api.put('/kpis/atencion/columnas', parte);
        guardado.current = { ...guardado.current, ...parte };
        toast.success('Columnas guardadas para todos', { id: 'atencion-cols' });
      } catch (e) {
        setCfg(guardado.current);
        toast.error(e.response?.data?.detail || 'No se pudieron guardar las columnas', { id: 'atencion-cols' });
      }
    });
  };
  return <Ctx.Provider value={{ cfg, puede, guardar }}>{children}</Ctx.Provider>;
};

export const useColumnasCfg = () => useContext(Ctx);
